import PropTypes from "prop-types";

export default {
    collectionName: PropTypes.string.isRequired,
    creatorName: PropTypes.string.isRequired,
    creatorCountry: PropTypes.string,
    creatorAvatarUrl: PropTypes.string.isRequired,
    totalIconCount: PropTypes.number.isRequired,
    downloadUrl: PropTypes.string
};
